<template >
  <section>
     <!-- Content Header (Page header) -->
     <section class="content-header">
        <h1>
           MARCACIONES
           <small>Percy</small>
        </h1>
        <ol class="breadcrumb">
           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
           <li class="active">Marcaciones</li>
        </ol>
     </section>
     <!-- Main content -->
     <section class="content">
        <div class="row">
        <!-- left column -->
        <div class="col-md-12">
          <div class="box box-primary">

            <div class="box-header with-border">
                 <h3 class="box-title">CONSULTA DE DATOS</b></h3>
              </div>

            <div class="content table-responsive table-full-width" >
               <table class="table table-condensed">
                  <thead>
                     <tr class="active">
                      <th>FECHA</th>
                    <!--  <th>HORA ING.</th>-->
                      <th>OBSERVACIÓN.</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="marc in list_marcacion">
                      <td data-title="CÓDIGO">{{marc.checkdate}}</td>
                      <!--<td data-title="NÚMERO">Dakota Rice</td>-->
                      <td data-title="DEMANDANTE">{{marc.descripcion}}</td>
                     </tr>
                  </tbody>
               </table>
            </div>


          </div>
        </div>
      </div>
     </section>
  </section>
</template>
<script>


  import config from '../../config';


  export default {
    name : 'MarcacionesDetalle',
    data(){
        return {
          alg : [1,3,5,6,7,3],
          list_marcacion : []
      }
    },
    computed : {
      marcacion(){
        return this.$store.getters.marcacion;

      }
    },
    mounted(){

      console.log('Entonces ahora hacemos esto , hacemos una marcacion del dia',this.marcacion);
      //preparamos la fechas
      let fecha = this.marcacion.fecha;
      fecha = fecha.split('/');
      let fecha_p = fecha[2] + fecha[1] + fecha[0];
    //  fecha_p = '20180112';



              swal({
                title: "Cargando...",
                text: " ",
                icon: "info",
                buttons: false,
                dangerMode: true,
              })



      console.log('Consultamos' ,config.serverURI + 'aplicaciones/marcadetalle/100255/'+fecha_p );
      axioss.get(config.serverURI + 'aplicaciones/marcadetalle/100255/'+fecha_p)
        .then((response)=>{

          swal.close();

          console.log('DDETALLE de ' , response);
          this.list_marcacion = response.data;

        })
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/views/MarcacionesDetalle.vue